module.exports = __webpack_public_path__ + "img/camera-timer.6245ae1c.svg";